<template>
    <div class="hospitalList">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="info-wrap">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">医院列表</span>
            </div>
            <div class="select-form">
                <div class="show-wrap">
                    <div class="search-show-wrap">
                        <el-input class="search-input"
                                  size="small"
                                  placeholder="请输入医院名称"
                                  v-model="selectForm.name"
                                  @keyup.enter.native="searchHospital('search')">
                            <i slot="suffix"
                               class="iconfont icon-search"
                               @click="searchHospital('search')"></i>
                        </el-input>
                        <div class="more-search"
                             @click="isMoreShow=!isMoreShow">
                            <span class="more-search-text">高级搜索</span>
                            <i class="iconfont icon-drop_down"
                               :class="[{'is-reverse': isMoreShow}]"></i>
                        </div>
                    </div>
                    <el-button size="small"
                               @click="toADD">新增医院</el-button>
                </div>
                <div class="hide-wrap"
                     v-if="isMoreShow">
                    <div class="option-wrap">
                        <div class="option-item">
                            <span class="label">医院等级</span>
                            <el-select v-model="selectForm.rank"
                                       placeholder="请选择"
                                       size="small"
                                       :style="{width: '240px'}"
                                       @change="handleRankChange">
                                <el-option value="all"
                                           label="全部"></el-option>
                                <el-option v-for="(item, index) in rankList"
                                           :key="index"
                                           :label="item.dictDataValue"
                                           :value="item.dictDataCode">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="option-item">
                            <span class="label">医院属性</span>
                            <el-select v-model="selectForm.type"
                                       placeholder="请选择"
                                       size="small"
                                       :style="{width: '240px'}"
                                       @change="handleTypeChange">
                                <el-option value="all"
                                           label="全部"></el-option>
                                <el-option v-for="(item, index) in typeList"
                                           :key="index"
                                           :label="item.dictDataValue"
                                           :value="item.dictDataCode">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="option-item">
                            <span class="label">创建时间</span>
                            <el-date-picker size="small"
                                            clearable
                                            clear-icon="el-icon-error"
                                            v-model="selectForm.createTime"
                                            type="daterange"
                                            range-separator="-"
                                            start-placeholder="yyyy-mm-dd"
                                            end-placeholder="yyyy-mm-dd"
                                            value-format="yyyy-MM-dd"
                                            :style="{width: '240px'}"
                                            @change="handleDateChange"
                                            :picker-options="datePickerOptions"></el-date-picker>
                        </div>
                        <div class="option-item">
                            <span class="label">所在地区</span>
                            <el-select v-model="selectForm.province"
                                       placeholder="省"
                                       size="small"
                                       :style="{width: '150px'}"
                                       @change="changeProvince">
                                <el-option :label="item.name"
                                           :value="item.code"
                                           v-for="(item, index) in provinceList"
                                           :key="index"></el-option>
                            </el-select>
                            <el-select v-model="selectForm.city"
                                       placeholder="市"
                                       size="small"
                                       :style="{width: '150px'}"
                                       @change="changeCity">
                                <el-option :label="item.name"
                                           :value="item.code"
                                           v-for="(item, index) in cityList"
                                           :key="index"></el-option>
                            </el-select>
                            <el-select v-model="selectForm.area"
                                       placeholder="区"
                                       size="small"
                                       :style="{width: '150px'}"
                                       @change="handleTypeChange">
                                <el-option :label="item.name"
                                           :value="item.code"
                                           v-for="(item, index) in areaList"
                                           :key="index"></el-option>
                            </el-select>
                        </div>
                        <div class="select-btn-wrap">
                            <el-button type="primary"
                                       size="small"
                                       @click="searchHospital('search')">查询</el-button>
                            <el-button type="info"
                                       size="small"
                                       plain
                                       @click="searchHospital('reset')">重置</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-wrap">
                <el-table :data="hospitalList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column prop="name"
                                     width="90px"
                                     type="index"
                                     label="序号">
                    </el-table-column>
                    <el-table-column prop="hospitalName"
                                     min-width="140px"
                                     label="医院名称">
                        <template slot-scope="scope">
                            {{scope.row.hospitalName}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="hospitalLevel"
                                     min-width="90px"
                                     label="医院等级">
                        <template slot-scope="scope">
                            <!-- {{rankList.find(rank =>rank.dictDataCode == scope.row.hospitalLevel)
                                ? rankList.find(rank =>rank.dictDataCode == scope.row.hospitalLevel).dictDataValue
                                : '-'}} -->
                            {{scope.row.hospitalLevelName || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="hospitalAttribute"
                                     min-width="90px"
                                     label="医院属性">
                        <template slot-scope="scope">
                            {{scope.row.hospitalAttributeName || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="hospitalPower"
                                     min-width="90px"
                                     label="医院权限">
                        <template slot-scope="scope">
                            {{scope.row.hospitalPowerName || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="hospitalPowerLevel"
                                     min-width="150px"
                                     label="医院权限等级">
                        <template slot-scope="scope">
                            {{scope.row.hospitalPowerLevelName || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="doctorCount"
                                     min-width="140px"
                                     label="医生数量(人)">
                        <template slot-scope="scope">
                            {{scope.row.doctorCount || '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="departmentCount"
                                     min-width="140px"
                                     label="科室数量">
                        <template slot-scope="scope">
                            {{scope.row.departmentCount || '-'}}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="groupCount"
                                     min-width="140px"
                                     label="医生集团数量">
                        <template slot-scope="scope">
                            {{scope.row.groupCount || '-'}}
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="createTime"
                                     min-width="140px"
                                     label="创建时间">
                        <template slot-scope="scope">
                            {{scope.row.createTime|getDate}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="name"
                                     width="130px"
                                     fixed="right"
                                     label="操作">
                        <template slot-scope="scope">
                            <span class="link-btn"
                                  @click="goDetail(scope.row, 'edit')">编辑</span>
                            <span class="link-btn"
                                  @click="goDetail(scope.row, 'show')">查看</span>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="pageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total"></el-pagination>
            </div>
        </div>

    </div>
</template>
<style lang="scss">
.hospitalList {
    .show-wrap {
        .el-button--small {
            width: 86px;
            font-size: 14px;
            padding: 8px 15px;
        }
    }
    .select-btn-wrap {
        font-size: 0;
        .el-button--small {
            width: 80px;
            padding: 8px 15px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            background: #f5f5f5;
            border-color: #cccccc;
            color: #666;
        }
    }
    .option-item {
        .el-select {
            margin-right: 10px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.info-wrap {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    top: 50px;
    padding: 20px;
    overflow: auto;
}
.title-wrap {
    font-size: 0;
    padding-bottom: 20px;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}
.show-wrap {
    display: flex;
    justify-content: space-between;
    .search-show-wrap {
        display: flex;
    }
    .more-search {
        font-size: 0;
        color: #666;
        padding-left: 10px;
        cursor: pointer;
    }
    .more-search-text {
        font-size: 14px;
        line-height: 32px;
        padding-right: 3px;
    }
    .icon-drop_down {
        display: inline-block;
        font-size: 12px;
        color: #999;
        transition: transform 0.3s;
        transform: rotateZ(180deg);
        &.is-reverse {
            transform: rotateZ(0deg);
        }
    }
}
.hide-wrap {
    margin-top: 8px;
    background: #f7f7f7;
    border: 1px solid #e6e6e6;
    padding: 20px 0 0 20px;
}

.option-item {
    display: inline-block;
    font-size: 0;
    margin-right: 20px;
    margin-bottom: 20px;
    .label {
        padding-right: 10px;
        font-size: 14px;
        color: #666;
        display: inline-block;
        width: 56px;
        text-align: right;
    }
    &:last-child {
        margin-right: 0;
    }
}
.select-btn-wrap {
    display: inline-block;
    margin-bottom: 20px;
}
.table-wrap {
    margin-top: 20px;
    .table-none {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .icon {
            font-size: 100px;
        }
        span {
            line-height: 14px;
        }
    }
}
.link-btn {
    cursor: pointer;
    color: $a-link;
    font-size: 12px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-right: 1px solid $a-link;
    margin-right: 6px;
    padding-right: 6px;
    &:last-child {
        border-right: none;
        margin-right: 0;
        padding-right: 0;
    }
}
</style>
<script>
import { mapGetters } from 'vuex'
import shortcuts from '@/utils/pickerOptions'
import { dateToString } from '@/utils/tools'
export default {
    name: 'hospitalList',
    data () {
        return {
            breadList: [{ label: '医院管理' }, { label: '医院列表' }],
            datePickerOptions: {
                shortcuts: shortcuts
            },
            isMoreShow: false,
            selectForm: {
                name: '',
                rank: '',
                createTime: [],
                startTime: '',
                endTime: '',
                province: '',
                city: '',
                area: ''
            },
            rankList: [],
            typeList: [],
            limitList: [],
            limitRankList: [],
            provinceList: [],
            cityList: [],
            areaList: [],
            page: {
                current: 1,
                total: 1,
                pageSize: 15
            },
            hospitalList: [],
            loading: true
        }
    },
    computed: {
        ...mapGetters([
            'dictionary'
        ])
    },
    methods: {
        // 获取省市区数据
        async getAddressData (type, level, pcode, searchName) {
            const param = {
                level: level,
                pcode: pcode,
                searchName: searchName
            }
            const { results } = await this.$services.user.getAddress(param)
            if (type === 'province') {
                this.provinceList = results
            } else if (type === 'city') {
                this.cityList = results
            } else if (type === 'area') {
                this.areaList = results
            }
        },
        changeProvince (value) {
            this.cityList = []
            this.areaList = []
            this.selectForm.city = ''
            this.selectForm.area = ''
            this.getAddressData('city', 2, value, '')
        },
        changeCity (value) {
            this.areaList = []
            this.selectForm.area = ''
            this.getAddressData('area', 3, value, '')
        },
        handleRankChange (value) {
            if (value) {
                this.selectForm.rank = value
            } else {
                this.selectForm.rank = ''
            }
        },
        handleTypeChange (value) {

        },
        handleDateChange (value) {
            if (value) {
                this.selectForm.startTime = value[0] + ' 00:00:00'
                this.selectForm.endTime = value[1] + ' 23:59:59'
            } else {
                this.selectForm.startTime = ''
                this.selectForm.endTime = ''
            }
        },
        searchHospital (type) {
            if (type === 'search') {
                this.page.current = 1
                this.getData()
            } else if (type === 'reset') {
                this.page.current = 1
                this.selectForm.startTime = ''
                this.selectForm.endTime = ''
                this.selectForm.rank = ''
                this.selectForm.type = ''
                this.selectForm.name = ''
                this.selectForm.province = ''
                this.selectForm.city = ''
                this.selectForm.area = ''
                this.selectForm.createTime = []
                this.getData()
            }
        },
        pageChange (value) {
            this.page.current = value
            this.getData()
        },
        async getData () {
            this.loading = true
            const param = {
                current: this.page.current,
                size: this.page.pageSize,
                createTimeStart: this.selectForm.startTime,
                createTimeEnd: this.selectForm.endTime,
                hospitalLevelCode: this.selectForm.rank === 'all' ? '' : this.selectForm.rank,
                hospitalAttributeCode: this.selectForm.type === 'all' ? '' : this.selectForm.type,
                searchName: this.selectForm.name,
                provinceCode: this.selectForm.province,
                cityCode: this.selectForm.city,
                districtCode: this.selectForm.area
            }
            const { results, total } = await this.$services.hospital.getHospitalList(param)
            this.hospitalList = results
            this.page.total = total
            this.loading = false
        },
        goDetail (item, type) {
            this.$router.push({
                name: 'hospitalDetail',
                query: { hospitalId: item.hospitalId, type: type }
            })
        },
        toADD () {
            this.$router.push('/hospital/hospitalList/add')
        }
    },
    filters: {
        getDate (value) {
            if (value) {
                const date = new Date(value)
                return dateToString(date, 'yyyy-MM-dd hh:mm')
            } else {
                return value
            }
        }
    },
    created () {
        this.getAddressData('province', 1, '', '')
        this.rankList = this.dictionary.YYDJ
        this.typeList = this.dictionary.YYSX
        this.limitList = this.dictionary.YYQX
        this.limitRankList = this.dictionary.YYQXDJ
        this.getData()
    }
}
</script>
